<form [formGroup]="editTabNameForm" *ngIf="!isSuperUser || selectedOnBehalfUser">
  <tabset>
    <tab *ngFor="let tabz of tabs; let tabIndex = index;"
         [active]="tabz.active"
         (selectTab)="selectTab(tabz)"
         (deselect)="deselectTab(tabz)"
         [disabled]="tabz.disabled || (editTabNameForm.invalid && tabs.indexOf(tabz) !== activeTab)"
         [removable]="tabz.removable"
         (removed)="removeTabHandler(tabz)"
         [customClass]="tabz.customClass"
         formArrayName="tabs">
      <ng-template *ngIf="tabz.removable" tabHeading>
        <span (clickOutside)="clickOutsideSubmit()" (keyup.enter)="submitTabName()" [formGroupName]="tabIndex - 1">
          <input *ngIf="tabz.active"
                 [size]="tabNameInput.value.length !== 0 ? tabNameInput.value.length : tabz.name.length"
                 formControlName="tabName"
                 #tabNameInput
                 data-lpignore="true"
                 maxlength="20"
                 class="tabNameInput"
                 type="text">
          <span *ngIf="!tabz.active" class="tabNameInput">{{tabz.name}}</span>
        </span>
      </ng-template>

      <ng-template *ngIf="!tabz.removable" tabHeading>
        <span>{{tabz.name}}</span>
      </ng-template>

      <div class="row" cdkDropList (cdkDropListDropped)="drop($event, tabIndex)">

        <!-- CARD START -->
        <div *ngFor="let card of tabz.cards | orderBy:'index', let i = index" class="col-12 col-md-6 col-xl-3"
             cdkDragLockAxis="x" cdkDrag [cdkDragDisabled]="isDragDisabled">
          <div class="card" id="{{'CARD_' + i}}">
            <div class="card-header">
              <div class="row">
                <!-- left side -->
                <div class="col-2">
                  <app-swap-type-selector [selectedTenorId]="card.swap" [tenors]="Tenors"
                                          (swapTypeChanged)="swapTypeChanged($event, card, i)"></app-swap-type-selector>
                </div>

                <div class="col-2 d-flex align-items-center">Lending</div>

                <!-- middle  -->
                <div class="col-4 d-flex justify-content-center">
                  <ng-select [items]="currencyPairs"
                             (ngModelChange)="changeCurrencyPair($event, tabIndex, card)"
                             [ngModelOptions]="{standalone: true}"
                             [(ngModel)]="card.sixLetterCode"
                             [inputAttrs]="{'data-lpignore': 'true'}"
                             placeholder="{{card.instrument}}"
                             [clearable]="false"
                             #cpSelect
                             [searchFn]="searchInstrument"
                             bindLabel="instrument.name"
                             bindValue="sixLetterCode"
                             [hideSelected]="true"
                             class="sixletter-dropdown">
                    <ng-template ng-option-tmp let-item="item">
                      <label class="mb-0" id="{{item.instrument.name}}">{{item.instrument.name}}</label>
                    </ng-template>
                  </ng-select>
                  <!--                  <app-currency-selector-->
                  <!--                    [currencyPairs]="currencyPairs"-->
                  <!--                    [(ngModel)]="card.sixLetterCode"-->
                  <!--                    [ngModelOptions]="{standalone: true}"-->
                  <!--                    (ngModelChange)="changeCurrencyPair($event, tabIndex, card)"-->
                  <!--                  ></app-currency-selector>-->
                  <!--                  <ng-select [items]="currencyPairs"-->
                  <!--                             (ngModelChange)="changeCurrencyPair($event, tabIndex, card)"-->
                  <!--                             [ngModelOptions]="{standalone: true}"-->
                  <!--                             [(ngModel)]="card.sixLetterCode"-->
                  <!--                             placeholder="{{card.sixLetterCode}}"-->
                  <!--                             [clearable]="false"-->
                  <!--                             #cpSelect-->
                  <!--                             bindLabel="sixLetterCode"-->
                  <!--                             bindValue="sixLetterCode"-->
                  <!--                             [hideSelected]="true"-->
                  <!--                             id="{{'CURRENCY_SELECTOR_' + i}}"-->
                  <!--                             class="sixletter-dropdown">-->
                  <!--                    <ng-template ng-option-tmp let-item="item">-->
                  <!--                      <label class="mb-0" id="{{item.sixLetterCode}}">{{item.sixLetterCode | formatSixLetter}}</label>-->
                  <!--                    </ng-template>-->
                  <!--                  </ng-select>-->
                </div>

                <!-- right side -->
                <div class="currMarket col-4 d-flex justify-content-end align-items-center"
                     *ngIf="getCurrentMarket(card.sixLetterCode)">
                  <div>{{getFormattedSpotPrice(card, false) | number:'1.0'}}<span
                    *ngIf="getFormattedSpotPrice(card, true)">.{{getFormattedSpotPrice(card, true)}}</span>
                  </div>
                </div>
                <div class="col-3 d-flex justify-content-end align-items-center"
                     *ngIf="!getCurrentMarket(card.sixLetterCode)">—
                </div>

              </div><!-- row end -->
            </div>
            <!-- ----------------------------------- CARD header END --------------------------- -->

            <div class="card-body">
              <div class="row overblock">
                <div class="col-5 d-flex justify-content-center align-self-center">
                  {{currencyPairsJson[card.sixLetterCode].instrument.baseCcy}} {{ 'labelOffered' | translate }} <i
                  class="fa fa-at"
                  aria-hidden="true"></i>
                </div>

                <div class="col-2 overhead d-flex justify-content-center align-self-center">
                  <rl-graph *ngIf="getGraphDataForCp(card.sixLetterCode)" class="col-4 graph"
                            [data]="getGraphDataForCp(card.sixLetterCode)" [options]="{lineWidth: 7}">
                  </rl-graph>
                </div>

                <div class="col-5 d-flex justify-content-center align-self-center">
                  {{currencyPairsJson[card.sixLetterCode].instrument.termCcy}} {{ 'labelOffered' | translate }} <i
                  class="fa fa-at"
                  aria-hidden="true"></i>
                </div>
              </div>

              <div class="row">
                <div class="col-6 lPrice">
                  <h2 *ngIf="getPricesForCurrencyPair(card, 'BORROW') && getPricesForCurrencyPair(card, 'BORROW')[0]"
                      (click)="openTradeModal(card, i,'LEND', 'borrowSidePrice')"
                      [classes]="(getPricesForCurrencyPair(card, 'BORROW')[0]?.price) <= 0 ? 'greenTooltipPopup tooltiptext' : 'yellowTooltipPopup tooltiptext'"
                      [customTooltip]="tooltipTemplate">
                    {{formatCP(((getPricesForCurrencyPair(card, 'BORROW')[0]?.price) | priceFactorPipe:card.sixLetterCode), 0.01)[0] | deletePointIfCpIsJpy: card.sixLetterCode }}
                    <span
                      *ngIf="!card.sixLetterCode.includes('JPY')">{{formatCP((getPricesForCurrencyPair(card, 'BORROW')[0]?.price | priceFactorPipe:card.sixLetterCode), 0.01)[1]}}</span>

                    <ng-template #tooltipTemplate>
                                          <span class="tooltiptext">
  <em class="fs-4">Borrow <b class="fw-bold">{{currencyPairsJson[card.sixLetterCode].instrument.baseCcy}}</b></em><br>

    <b class="fw-bold" *ngIf="(getPricesForCurrencyPair(card, 'BORROW')[0]?.price) >= 0">EARNING</b>
    <b class="fw-bold" *ngIf="(getPricesForCurrencyPair(card, 'BORROW')[0]?.price) < 0">COST</b>
                                            {{(currencyPairsJson[card.sixLetterCode].instrument.termCcy) | getCurrencySymbol}}
                                            {{Math.abs(getPricesForCurrencyPair(card, 'BORROW')[0]?.price | number:'1.2-2')}}
                                            /
        <span [innerHTML]="getTooltipDays(card.swap)"></span> for 1
                                            {{currencyPairsJson[card.sixLetterCode].instrument.baseCcy}}
                                            <br>
  ({{Math.abs(getPricesForCurrencyPair(card, 'BORROW')[0]?.price | number:'1.2-2')}} x <span
                                            [innerHTML]="getDaysDividerToSwapRateByTradeType(card.swap)"></span>) / Spot<br>
  <i class="fs-4">= {{Math.abs((getPricesForCurrencyPair(card, 'BORROW')[0]?.price * 100) * getDaysDividerToSwapRateByTradeTypeForCalculation(card.swap)) /
  getCurrentMarket(card.sixLetterCode) | number:'1.2-2'}}% (APR)</i>
  </span>
                    </ng-template>

                  </h2>
                  <h2 *ngIf="!getPricesForCurrencyPair(card, 'BORROW')" class="noprice d-flex justify-content-center">
                    <i class="fa fa-minus"></i>
                  </h2>
                </div>


                <div class="col-6 rPrice">
                  <h2 *ngIf="getPricesForCurrencyPair(card, 'LEND') && getPricesForCurrencyPair(card, 'LEND')[0]"
                      (click)="openTradeModal(card, i,'BORROW', 'lendSidePrice')"
                      class="tooltipTitle"
                      [classes]="(getPricesForCurrencyPair(card, 'LEND')[0]?.price) <= 0 ? ' yellowTooltipPopup  tooltiptext' : 'greenTooltipPopup tooltiptext'"
                      [customTooltip]="tooltipTemplateRight">

                    {{formatCP(((getPricesForCurrencyPair(card, 'LEND')[0]?.price) | priceFactorPipe:card.sixLetterCode), 0.01)[0] | deletePointIfCpIsJpy: card.sixLetterCode }}
                    <span
                      *ngIf="!card.sixLetterCode.includes('JPY')">{{formatCP((getPricesForCurrencyPair(card, 'LEND')[0]?.price | priceFactorPipe:card.sixLetterCode), 0.01)[1]}}</span>

                    <ng-template #tooltipTemplateRight>
                          <span class="tooltiptext">
  <em class="fs-4">Borrow <b class="fw-bold">{{currencyPairsJson[card.sixLetterCode].instrument.termCcy}}</b></em><br>

  <b class="fw-bold" *ngIf="(getPricesForCurrencyPair(card, 'LEND')[0]?.price) >= 0">COST</b>
  <b class="fw-bold" *ngIf="(getPricesForCurrencyPair(card, 'LEND')[0]?.price) < 0">EARNING</b>

                            {{(currencyPairsJson[card.sixLetterCode].instrument.termCcy) | getCurrencySymbol}}{{Math.abs(getPricesForCurrencyPair(card, 'LEND')[0]?.price | number:'1.2-2')}}
                            /<span
                            [innerHTML]="getTooltipDays(card.swap)"></span> for 1 {{currencyPairsJson[card.sixLetterCode].instrument.baseCcy}}
                            <br>
  ({{Math.abs(getPricesForCurrencyPair(card, 'LEND')[0]?.price | number:'1.2-2')}} x <span
                            [innerHTML]="getDaysDividerToSwapRateByTradeType(card.swap)"></span>) / Spot<br>
    <i class="fs-4">= {{Math.abs((getPricesForCurrencyPair(card, 'LEND')[0]?.price * 100) * getDaysDividerToSwapRateByTradeTypeForCalculation(card.swap)) /
    getCurrentMarket(card.sixLetterCode) | number:'1.2-2'}}% (APR)</i>
  </span>
                    </ng-template>


                  </h2>
                  <h2 *ngIf="!getPricesForCurrencyPair(card, 'LEND')" class="noprice d-flex justify-content-center">
                    <i class="fa fa-minus"></i>
                  </h2>
                </div>
              </div>

              <div class="ticker">
                <span>{{getAbsOfLatestTradeForCP(card.sixLetterCode) | priceFactorPipe:card.sixLetterCode | number:'1.0'}}</span>
                <i *ngIf="getLastTradeForCp(card.sixLetterCode) !== ''"
                   [ngClass]="getLastTradeForCp(card.sixLetterCode) > 0 ? 'fa-long-arrow-up' : 'fa-long-arrow-down'"
                   class="fa"></i>
              </div>

              <div class="row">
                <div class="col-6 leftprice price">
                  <div class="d-flex justify-content-between">

                    <div class="amount" *ngIf="getPricesForCurrencyPair(card, 'BORROW')"
                         (click)="openTradeModal(card, i, 'LEND', 'borrowSideAmount')">
                      ({{currencyPairsJson[card.sixLetterCode].instrument.termCcy}}
                      {{(getCurrentMarket(card.sixLetterCode) * (getPricesForCurrencyPair(card, 'BORROW')[0]?.quantity)) | shortNumberFormatByCurrencyPair:card.sixLetterCode}}
                      )
                    </div>

                    <div class="amount" id="{{'CARD_' + i + '_BORROW_SIDE_QUANTITY'}}"
                         *ngIf="getPricesForCurrencyPair(card, 'BORROW')"
                         (click)="openTradeModal(card, i,'LEND', 'borrowSideQuantity')">
                      {{getPricesForCurrencyPair(card, 'BORROW')[0]?.quantity | number:'1.0'}}
                    </div>

                    <div *ngIf="!getPricesForCurrencyPair(card, 'BORROW')">&nbsp;</div>

                  </div>
                </div>

                <div class="col-6 price">
                  <div class="d-flex justify-content-between">

                    <div class="amount" id="{{'CARD_' + i + '_LEND_SIDE_QUANTITY'}}"
                         *ngIf="getPricesForCurrencyPair(card, 'LEND')"
                         (click)="openTradeModal(card, i,'BORROW', 'lendSideQuantity')">
                      {{getPricesForCurrencyPair(card, 'LEND')[0]?.quantity | number:'1.0'}}
                    </div>

                    <div *ngIf="!getPricesForCurrencyPair(card, 'LEND')">&nbsp;</div>

                    <div class="amount" *ngIf="getPricesForCurrencyPair(card, 'LEND')"
                         (click)="openTradeModal(card, i,'BORROW', 'lendSideAmount')">
                      ({{currencyPairsJson[card.sixLetterCode].instrument.termCcy}}
                      {{getCurrentMarket(card.sixLetterCode) * (getPricesForCurrencyPair(card, 'LEND')[0]?.quantity) | shortNumberFormatByCurrencyPair:card.sixLetterCode}}
                      )
                    </div>

                  </div>
                </div>

              </div>
            </div>

            <div class="card-footer d-flex flex-column">

              <div class="row minitable">
                <div class="col-3 text-center miniL">
                  <b>{{ 'labelQty' | translate }}<br>({{currencyPairsJson[card.sixLetterCode].instrument.baseCcy}})</b>

                  <table class="mx-auto" *ngIf="getPricesForCurrencyPair(card, 'BORROW')">
                    <tr *ngFor="let item of getRemainingOrders(card, 'BORROW')">
                      <td></td>

                      <td colspan="2"
                          *ngIf="formatCP((item.quantity), 0.01)[1] == '00' && (item.quantity >= 1000 || item.quantity <= -1000)">
                        {{formatCP((item.quantity), 0.01)[0] | shortNumber}}
                      </td>

                      <td *ngIf="formatCP((item.quantity), 0.01)[1] != '00' && item.quantity >= 1000">
                        {{formatCP((item.quantity), 0.01)[0]}}
                      </td>

                      <td *ngIf="formatCP((item.quantity), 0.01)[1] != '00' && item.quantity >= 1000">
                        {{formatCP((item.quantity), 0.01)[1] }}
                      </td>

                      <td
                        *ngIf="(item.quantity <= 999)">{{formatCP((item.quantity), 0.01)[0]}}</td>
                      <td
                        *ngIf="(item.quantity <= 999)">{{formatCP((item.quantity), 0.01)[1]}}</td>

                      <td></td>

                    </tr>
                  </table>

                </div>

                <div class="col-3 text-center miniL">
                  <b>{{ 'labelPrice' | translate }}<br>({{currencyPairsJson[card.sixLetterCode].instrument.termCcy}}
                    )</b>

                  <table class="mx-auto" *ngIf="getPricesForCurrencyPair(card, 'BORROW')">
                    <tr *ngFor="let item of getRemainingOrders(card, 'BORROW')">
                      <td></td>
                      <td colspan="2" *ngIf="formatCP((item.price), 0.01)[1] == '00' && item.price >= 1000">
                        {{formatCP((item.price | priceFactorPipe:card.sixLetterCode), 0.01)[0] | shortNumber}}
                      </td>

                      <td *ngIf="formatCP((item.price), 0.01)[1] != '00' && item.price >= 1000">
                        {{formatCP((item.price), 0.01)[0] | priceFactorPipe:card.sixLetterCode}}
                      </td>

                      <td *ngIf="formatCP((item.price), 0.01)[1] != '00' && item.price >= 1000">
                        {{formatCP((item.price), 0.01)[1] | priceFactorPipe:card.sixLetterCode}}
                      </td>

                      <td
                        *ngIf="(item.price <= 999)">{{formatCP((item.price | priceFactorPipe:card.sixLetterCode), 0.01)[0]}}</td>
                      <td
                        *ngIf="(item.price <= 999)">{{formatCP((item.price | priceFactorPipe:card.sixLetterCode), 0.01)[1]}}</td>

                      <td></td>
                    </tr>
                  </table>

                </div>

                <div class="col-3 text-center miniL">
                  <b>{{ 'labelPrice' | translate }}<br>({{currencyPairsJson[card.sixLetterCode].instrument.termCcy}}
                    )</b>

                  <table class="mx-auto" *ngIf="getPricesForCurrencyPair(card, 'LEND')">
                    <tr *ngFor="let item of getRemainingOrders(card, 'LEND')">
                      <td></td>
                      <td *ngIf="formatCP((item.price), 0.01)[1] == '00' && item.price >= 1000">
                        {{formatCP((item.price | priceFactorPipe:card.sixLetterCode), 0.01)[0] | shortNumber}}
                      </td>

                      <td *ngIf="formatCP((item.price), 0.01)[1] != '00' && item.price >= 1000">
                        {{formatCP((item.price | priceFactorPipe:card.sixLetterCode), 0.01)[0]}}
                      </td>

                      <td *ngIf="formatCP((item.price), 0.01)[1] != '00' && item.price >= 1000">
                        {{formatCP((item.price | priceFactorPipe:card.sixLetterCode), 0.01)[1] }}
                      </td>

                      <td
                        *ngIf="(item.price <= 999)">{{formatCP((item.price | priceFactorPipe:card.sixLetterCode), 0.01)[0]}}</td>
                      <td
                        *ngIf="(item.price <= 999)">{{formatCP((item.price | priceFactorPipe:card.sixLetterCode), 0.01)[1]}}</td>

                      <td></td>
                    </tr>
                  </table>

                </div>

                <div class="col-3 text-center">
                  <b>{{ 'Qty' | translate }}<br>({{currencyPairsJson[card.sixLetterCode].instrument.baseCcy}})</b>

                  <table class="mx-auto" *ngIf="getPricesForCurrencyPair(card, 'LEND')">
                    <tr *ngFor="let item of getRemainingOrders(card, 'LEND')">
                      <td></td>

                      <td colspan="2" *ngIf="formatCP((item.quantity), 0.01)[1] == '00' && item.quantity >= 1000">
                        {{formatCP((item.quantity), 0.01)[0] | shortNumber}}
                      </td>

                      <td *ngIf="formatCP((item.quantity), 0.01)[1] != '00' && item.quantity >= 1000">
                        {{formatCP((item.quantity), 0.01)[0]}}
                      </td>

                      <td colspan="2" *ngIf="formatCP((item.quantity), 0.01)[1] != '00' && item.quantity >= 1000">
                        {{formatCP((item.quantity), 0.01)[1] }}
                      </td>

                      <td
                        *ngIf="(item.quantity <= 999)">{{formatCP((item.quantity), 0.01)[0]}}</td>
                      <td
                        *ngIf="(item.quantity <= 999)">{{formatCP((item.quantity), 0.01)[1]}}</td>

                    </tr>
                  </table>
                </div>
              </div>

              <div class="d-flex justify-content-between align-items-center footerbt">
                <button type="button" id="{{'card' + card.id}}" name="{{'card' + card.id}}"
                        class="btn btn-sm btn-info"
                        [disabled]="!getCurrentMarket(card.sixLetterCode)"
                        (click)="openTradeModal(card, i,'LEND', 'placeAnOrder')" tabindex="-1" translate><i
                  class="fa fa-angle-right" aria-hidden="true"></i> buttonPlaceOrder
                </button>


                <!--  quantity input -->
                <input class="aminput"
                       data-lpignore="true"
                       [name]="'input' + card.id"
                       [textMask]="{mask: mask}"
                       [(ngModel)]="card.amount"
                       [ngModelOptions]="{standalone: true}"
                       (mouseleave)="enableDragging()"
                       (mouseenter)="disableDragging()"
                       (click)="selectEvent($event)"
                       (keydown)="validateFloatKeyPress($event, card)"
                       autocomplete="off"/>
              </div>
            </div>
          </div>

        </div>

      </div>
    </tab>

    <tab [disabled]="true" heading="+" [id]="'plus'" customClass="addBoxTab"></tab>


  </tabset>
</form>


<ng-template #newTabModal>
  <div class="modal-header">
    <h6 class="modal-title" translate>addTitleForTheNewTabLabel</h6>
    <span type="button" class="btn-link" tabindex="-1" aria-label="Close" (click)="cancelNewTabModal()"> <i
      class="fa fa-lg fa-times"></i>
        </span>
  </div>
  <div class="modal-body">
    <form [formGroup]="newTabModalForm" (ngSubmit)="submitNewTab()">
      <input appAutoFocus autocomplete="off" formControlName="newTabName"
             (ngModelChange)="newTabModalForm.valid ? isOpen = false : null"
             placeholder="{{'addNewTabInputLabel' | translate}}" type="text" class="form-control mb-1 mt-2">

      <alert (onClosed)="isOpen=false" role="alert"
             *ngIf="(isOpen && newTabModalForm.invalid)">
        <!--        <div-->
        <!--          *ngIf="newTabModalForm.controls.newTabName.errors?.required && newTabModalForm.controls.newTabName.touched"-->
        <!--          translate>addTitleErrorMessage-->
        <!--        </div>-->
        <div
          *ngIf="(newTabModalForm.controls['newTabName'].errors && newTabModalForm.controls['newTabName'].errors['validateNewTabName']) && newTabModalForm.controls['newTabName'].touched"
          translate>addUniqueTabNameErrorMessage
        </div>
      </alert>

      <div class="text-right mt-4">
        <button type="button" class="btn btn-sm mr-2 btn-secondary" (click)="cancelNewTabModal()"
                translate>buttonCancel
        </button>

        <button type="submit" class="btn btn-sm btn-primary"
                [disabled]="newTabModalForm.get('newTabName').value === ''"
                translate>addNewTab.buttonAdd
        </button>
      </div>
    </form>
  </div>
</ng-template>
